import React from "react";
import {
	Redirect,
	Route,
	RouteProps,
	RouteComponentProps
} from "react-router-dom";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";
import Layout from "components/Layout";
import { IRootState } from "shared/reducer";
import isEmpty from "lodash/isEmpty";

interface IPrivateRouteProps extends RouteProps {
	hasAnyAuthorities?: string[];
}

const userAuthenticated = createSelector(
	(state: IRootState) => state.authentication,
	(_: any, hasAnyAuthorities: string[]) => hasAnyAuthorities,
	(authentication, hasAnyAuthorities) => ({
		isAuthorized: hasAnyAuthority(
			[authentication.account.role],
			hasAnyAuthorities
		),
		sessionHasBeenFetched: authentication.sessionFetched,
		isAuthenticated: authentication.isAuthenticated
	})
);

export const PrivateRoute = ({
	component: Component,
	hasAnyAuthorities = [],
	...rest
}: IPrivateRouteProps) => {
	const {
		isAuthorized,
		isAuthenticated,
		sessionHasBeenFetched
	} = useSelector((state: IRootState) =>
		userAuthenticated(state, hasAnyAuthorities)
	);

	const checkAuthorities = (props: RouteComponentProps<any>) =>
		isAuthorized ? (
			// @ts-ignore
			<Component {...props} />
		) : (
			<Layout>
				<Container maxWidth="md">
					<Typography variant="h4" color="error" align="center">
						Nincsen jogod megtekinteni ezt az oldalt.
					</Typography>
				</Container>
			</Layout>
		);

	const renderRedirect = (props: RouteComponentProps<any>) => {
		if (!sessionHasBeenFetched) {
			return (
				<Redirect
					to={{
						pathname: "/",
						search: props.location.search,
						state: { from: props.location }
					}}
				/>
			);
		} else {
			return isAuthenticated ? (
				checkAuthorities(props)
			) : (
				<Redirect
					to={{
						pathname: "/",
						search: props.location.search,
						state: { from: props.location }
					}}
				/>
			);
		}
	};

	if (!Component)
		throw new Error(
			`A component needs to be specified for private route for path ${rest.path}`
		);

	return <Route {...rest} render={renderRedirect} />;
};

export const hasAnyAuthority = (
	authorities: string[],
	hasAnyAuthorities: string[]
) => {
	if (!isEmpty(authorities)) {
		if (isEmpty(hasAnyAuthorities)) {
			return true;
		}
		return hasAnyAuthorities.some((auth: string) =>
			authorities.includes(auth)
		);
	}
	return false;
};

export default PrivateRoute;
